import React, { Component } from 'react'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
am4core.addLicense("CH258896422");

export default class RiCategoryHBarChart extends Component {
    componentDidMount() {
        let info = this.props
        let titleX = info['Xtitle']
        let titleY = info['Ytitle']

        // let card_name = info['name'];
        let chart_id = info['chart_id'];
        let data = info['graph-data'];
        let bar_color = info['bar_color'];

        
        let chart = am4core.create(chart_id, am4charts.XYChart);
        chart.fontFamily = "Ubuntu";//TO CHANGE FONT SIZE OF CHART LABELS
        chart.fontSize = 12;//TO CHANGE FONT SIZE OF CHART LABELS
        chart.data = data;
        chart.exporting.menu = new am4core.ExportMenu();

        chart.colors.list = [
            am4core.color(bar_color)
        ];

        chart.data = data;
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.title.text = titleX;
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.baseGrid.disabled = true;
        categoryAxis.renderer.grid.template.strokeWidth = 0;
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 1;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.labels.template.fill = am4core.color("#757575");
        categoryAxis.renderer.labels.template.fontSize = 12;
        categoryAxis.renderer.cellStartLocation = 0.3;
        categoryAxis.renderer.cellEndLocation = 0.5;
        categoryAxis.tooltip.disabled = true; // for disabling to the y axis tooltip
        
        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.title.text = titleY;
        valueAxis.numberFormatter.numberFormat = "#'%'"
        valueAxis.renderer.labels.template.fill = am4core.color("#757575");
        valueAxis.renderer.line.strokeOpacity = 0.2; // for reducing the Y axis opacity 
        valueAxis.renderer.line.stroke = am4core.color("#707070"); // for changing the Y axis color
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.renderer.labels.template.horizontalCenter = "right";
        valueAxis.tooltip.disabled = true; // for disabling to the y axis tooltip
        valueAxis.renderer.grid.template.location = 0;
        valueAxis.renderer.minGridDistance = 30;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = "category";
        series.dataFields.valueX = "value";
        series.tooltipText = "{categoryY}: [bold]{valueX}[/]"
        series.columns.template.strokeOpacity = 0;
        series.columns.template.column.cornerRadiusBottomRight = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.width = am4core.percent(5);
        series.tooltip.getFillFromObject = false;
        series.tooltip.background.fill = am4core.color("#213345");
        series.tooltip.background.stroke = am4core.color("#213345");
        series.tooltip.background.cornerRadius = 5;
        series.tooltip.label.fontSize = 12;
        series.tooltip.position = "pointer";
       
        var shadow = series.tooltip.background.filters.getIndex(0);
        shadow.dx = 3;
        shadow.dy = 10;
        shadow.blur = 10;
        shadow.color = am4core.color("#14567829");

        // Add chart cursor
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomY";

        chart.padding(10, 0, 0, 0);

    }

    render() {
        let chart_class = this.props.chart_class;
        let chart_id = this.props.chart_id;

        return (
            <div id={chart_id} className={chart_class}></div>
            // <div id="chartdiv"></div>
        )
    }
}
